export default __webpack_public_path__ + "static/media/249.175df660.png";